export enum ComboboxVirtualizerCssVars {
  /**
   * The total height of the virtualized content, including the scrollport's block padding.
   * @type {number}
   */
  totalSize = '--total-size',
}
